import { ContentStoreCategoriesService } from 'src/services/Categories';

export const mergeCategory = (
    { accessToken, id, replacementId }: App.Category.MergeMutationVariables,
): Promise<string> => ContentStoreCategoriesService.mergeCategory(accessToken, id, replacementId);
